import React from "react";
import axios from "axios";
import Chart from "react-apexcharts";
import ReportsError from './ReportsError';
import { 
    getFromLocalStorage,
    getGraphColours,  
    capitalizationWithExceptions
} from './Utilities';

class ReportsActivityTimelineChart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            services: props.services
        }
    }

    render() {
        const { services } = this.state.services;
        var xaxis = [];
        var graphData = [];

        //Xaxis
        if(services && Object.keys(services).length > 0){
            services[0].range.map(function(range, index){//get range from first entry
                xaxis[index] = range.Date;
            });
        
            //Graph data
            services.map(function(service, index){
                var data = [];
                service.range.map(function(range, index){
                    data[index] = range.Count;
                });

                graphData[index] = {
                    name: capitalizationWithExceptions(service.service),
                    data: data
                }
            });   
        }

        var params = {
            options: {
                chart: {
                    id: "report-line-chart"
                },
                xaxis: {
                    categories: xaxis
                },
                colors: getGraphColours()
            },
            series: graphData
        };
    
        return (
            <div className="row">
                <div className="mixed-chart">
                    <Chart
                        options={params.options}
                        series={params.series}
                        type="line"
                        width="85%"
                    />
                </div>
            </div>
        );
    }
}

class ReportsActivityTimeline extends React.Component {
    constructor(props) {
        super(props);

        var filters = getFromLocalStorage("report_data");
        const brandIDs = this.getBrandIDs(filters?.ChooseBrands);

        var endpoint = "brand/stats/timeline";
        
        if(brandIDs && brandIDs.length > 0){
            endpoint += "&brandids="+brandIDs;
        }
        var url = "react/process?endpoint=" + endpoint + "&hourly_cutoff=0&turnoffdebug=1&includeonetime=1";
        if(filters.ChooseActivities && filters.ChooseActivities.Segment) url += "&segmentid="+filters.ChooseActivities.Segment.ID;

        // Initializing state with the endpoint URL
        this.state = {
            url: url,
            services: [],
            total: null,
            view: props.view ? props.view : "table",
            isLoading: true,
            error: null
        };
    }

    getBrandIDs(brandData){
         var brands = {};
         if(brandData){
             brands = Object.values(brandData).map(function(obj, key){//sometimes first key is null, get valid brands
                if(typeof obj != "undefined") return obj.ID;
             });
         }
         if(Object.keys(brands).length > 1) return brands.join(",");
         return brands;   
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        // Fetch new data if the 'next' prop changes
        if (prevProps.next !== this.props.next) {
            this.getData();
        }
    }

    // Function to fetch data from the server
    getData() {
        if(this.state.url) axios.get(this.state.url).then(response => this.formatData(response.data));
    }

    // Function to format the fetched data
    formatData(data) {
        let services = data?.error ? [] : data;//error replaces services in response
        let error = data?.error || null;
        this.setState({ services: services, error: error?.message, isLoading: false});
    }

    render() {
        // console.log(this.state);
        if (this.state.isLoading) {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big"></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        } else if (Object.keys(this.state.services).length > 0) {
            return(
                <div className="chart-activitylist">
                    <ReportsActivityTimelineChart 
                        activities={this.state.activities}
                        services={this.state.services}
                    />
                </div>
            );
        } else {
            // Handling no results found
            return (
                <ReportsError error={this.state.error} type="activities" table="false" />
            );
        }
    }
}

export default ReportsActivityTimeline;
